module.exports = __webpack_public_path__ + "static/media/inktoberShroomPizza.856b932f.gif";